import styled from "styled-components";
import {CardElement} from "@stripe/react-stripe-js";
import {CancellationPolicyContent} from "pages/user/PaymentPage/components/CancellationPolicyContent";
import {Tooltip} from "ui/base/tooltip/Tooltip";
import {Field, FieldError, Label, tokens} from "ui/blocks/guestMessaging/GuestUI";

const cardStyle = {
    style: {
        base: {
            fontSize: "16px",
            color: "#1D1D1F",
            fontFamily: "Poppins, -apple-system, Roboto, Helvetica, Arial, sans-serif",
            "::placeholder": {color: "#9A9AAE"},
        },
        invalid: {color: "#D93025"},
    },
    hidePostalCode: false,
};

/** Stripe card entry styled like the other fields. onChange gets {complete, error}. */
export const CardField = ({onChange, error, disabled}) => (
    <Field>
        <Label as="span">Card details</Label>
        <CardBox $invalid={Boolean(error)} $disabled={disabled}>
            <CardElement
                options={{...cardStyle, disabled}}
                onChange={(e) => onChange?.({complete: e.complete, error: e.error?.message || ""})}
            />
        </CardBox>
        {error && <FieldError>{error}</FieldError>}
    </Field>
);

export const Agreement = ({cancellation, instructorName}) => (
    <AgreementText>
        By booking you agree to the{" "}
        <Tooltip
            id="booking-popup-cancellation"
            text={<CancellationPolicyContent policy={cancellation || []} fullName={instructorName}/>}
            display="inline"
            maxWidth="320px"
        >
            <u>cancellation policy</u>
        </Tooltip>{" "}
        and{" "}
        <a target="_blank" rel="noopener noreferrer" href="https://teache.co/policies/terms">Terms &amp; Conditions</a>.
        Your card is held, not charged, until {instructorName} accepts.
    </AgreementText>
);

const CardBox = styled.div`
    box-sizing: border-box;
    width: 100%;
    padding: 14px 16px;
    border: 1px solid ${({$invalid}) => ($invalid ? tokens.error : tokens.border)};
    border-radius: 12px;
    background: #fff;
    opacity: ${({$disabled}) => ($disabled ? 0.6 : 1)};
    transition: border-color 150ms ease;

    &:focus-within {
        border-color: ${tokens.accent};
    }
`;

const AgreementText = styled.p`
    margin: 0;
    font-size: 12.5px;
    line-height: 1.5;
    color: ${tokens.muted};

    a, u {
        color: ${tokens.text};
        cursor: pointer;
    }
`;
